// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


var _map = {"none":"none","copy":"copy","link":"link","move":"move"};

function dropEffectToJs(param) {
  return param;
}

function dropEffectFromJs(param) {
  return _map[param];
}

var _map$1 = {"none":"none","copy":"copy","link":"link","move":"move","copyLink":"copyLink","copyMove":"copyMove","all":"all","uninitialized":"uninitialized"};

function effectAllowedToJs(param) {
  return param;
}

function effectAllowedFromJs(param) {
  return _map$1[param];
}

var _map$2 = {"text":"text","url":"url","textHtml":"text/html"};

var _revMap = {"text":"text","url":"url","text/html":"textHtml"};

function formatToJs(param) {
  return _map$2[param];
}

function formatFromJs(param) {
  return _revMap[param];
}

var ItemList = {};

function getData(format, dataTransfer) {
  return dataTransfer.getData(formatToJs(format));
}

exports.dropEffectToJs = dropEffectToJs;
exports.dropEffectFromJs = dropEffectFromJs;
exports.effectAllowedToJs = effectAllowedToJs;
exports.effectAllowedFromJs = effectAllowedFromJs;
exports.formatToJs = formatToJs;
exports.formatFromJs = formatFromJs;
exports.ItemList = ItemList;
exports.getData = getData;
/* No side effect */
